import { useTranslation } from 'react-i18next';

const BasicInformation = () => {
  const { t } = useTranslation();
  const apiKey = '8afd5627-68bd-4d7c-bcf5-9b6a1f24623c';
  return (
    <div style={{ backgroundColor: 'white', padding: '20px' }}>
      <h1>Catch System</h1>
      <span>
        <strong>Api Key: {apiKey}</strong>{' '}
      </span>
      <span>
        {t('common.requiredApiKeyCatchInfo')}
      </span>
    </div>
  );
};

export default BasicInformation;
